import { useSelector } from "@xstate/react";

import { type EncounterStatus, encounterActor } from "../domain";

export function useEncounterId() {
  return useSelector(encounterActor, (s) => s.context.encounterId);
}

export function useEncounterStatusValue(): EncounterStatus {
  return useSelector(encounterActor, (s) => s.value as EncounterStatus);
}

export function useIsEncounterCompleted(): boolean {
  return useSelector(encounterActor, (s) => s.matches("completed"));
}

export function useIsEncounterFinalizing(): boolean {
  return useSelector(encounterActor, (s) => s.matches("finalizing"));
}

export function useIsEncounterConnected(): boolean {
  return useSelector(encounterActor, (s) => !s.matches("idle"));
}
